module.exports = __webpack_public_path__ + "static/media/595e25d7.jpg";